export default "__VITE_ASSET__Bwo9YJZQ__"